import classNames from 'classnames';
import { FlowWay } from 'components/common-form/sidePanel/status/cashFlowWayUtils';
import { useIsInternalUser } from 'hooks/useIsInternalUser';
import { IntlKey } from 'locales';
import { FC } from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';

export interface FlowWayLiteralProps {
  flowWay: FlowWay;
  priceInPercent: number;
  priceInCurrency: number;
  currency: string;
}

export const FlowWayLiteral: FC<FlowWayLiteralProps> = ({ flowWay, priceInPercent, priceInCurrency, currency }) => {
  const isInternalUser = useIsInternalUser();

  if (flowWay === 'NoFlowWay') {
    return null;
  }

  return (
    <div className="d-flex flex-column align-items-end">
      <div className="d-flex align-items-center mb-1">
        <div className={classNames({ 'pointer-right': flowWay === 'YouPaySgReceives' }, 'd-flex align-items-center')}>
          <span className="lh-1 fs-12" style={{ letterSpacing: '0.06em' }}>
            <FormattedMessage id={getIntlKey(flowWay, isInternalUser)} />
          </span>
        </div>
        <div className={`arrow-${flowWay === 'YouPaySgReceives' ? 'right' : 'left'} px-3`}>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div className="d-flex">
          <div
            className={classNames({ 'pointer-left': flowWay === 'YouReceiveSgPaysYou' }, 'd-flex align-items-center')}
          >
            <span className="lh-1 fs-12" style={{ letterSpacing: '0.06em' }}>
              SG
            </span>
          </div>
        </div>
      </div>
      <div className="fw-medium lh-1">
        <FormattedNumber style="percent" value={Math.abs(priceInPercent / 100)} maximumFractionDigits={4} />
        {' / '}
        <FormattedNumber currency={currency} value={Math.abs(priceInCurrency)} /> {currency}
      </div>
    </div>
  );
};

function getIntlKey(adjustedFlowWay: FlowWay, isInternalUser: boolean): IntlKey {
  const you = isInternalUser ? 'internalUser' : 'externalUser';

  if (adjustedFlowWay === 'YouPaySgReceives') {
    return `flowSense.${you}.YouPay`;
  }

  if (adjustedFlowWay === 'YouReceiveSgPaysYou') {
    return `flowSense.${you}.YouReceive`;
  }

  return 'flowSense.noFlowWay';
}
